<template lang="pug">
    v-app
        v-container(class="ta_brand_header_bg_clr" fluid)
            v-row(no-gutters)
                div(@click="goToStartPage()" class="header-logo")
                    v-img(src="/images/traders-alloy-logo_edger.svg")

                div(class="header-stuff mr-2" style="display:flex;")
                    v-autocomplete(@change="isPdfReportsTableLoaded"
                        :label="$t('Search_by_company_name')"
                        :placeholder="$t('Search_by_company_name')"
                        data-v-step='0'
                        :filter="customFilter"
                        :items="getAllStocks"
                        item-text="name"
                        item-value="ticker"
                        return-object
                        dense
                        solo
                        hide-details
                        :loading='loadingState' loader-height="3"
                        @input="onChange"
                        style="width:300px"
                        class="header-search mr-8")
                        template( v-slot:selection="data")
                            span
                        template(v-slot:item="data")
                            div(class="d-flex")
                                div
                                    Ticker(:stockId="data.item.stock_id")
                                div(class="ml-4" style="width:200px; border:0px solid;") {{data.item.name}}
                                div(class="ml-2" style="width:200px;") {{$t(data.item.sector_name)}}
                    div(style="position:absolute; top:75px; right:680px;")
                        v-snackbar( v-model="message.visible" absolute :timeout="3001" :color="message.type")
                            span( class="h4 white--text") {{message.text}}


                    // Login button
                    //div(v-show="!this.userSubscribed" class="header-btn brd-radius")
                        PremiumButton(@click.native="openPremiumWindow()" id="myPremiumButtonElement" ref="premiumButtonElement")

                    div(v-show="user.user_id === 0" class="header-btn brd-radius mr-3")
                        v-btn(@click="login()") Login


                    // Try for free button below
                    div(v-show="!this.userSubscribed" class="header-btn brd-radius clr-pink")
                        PremiumButton(@click.native="openPremiumWindow()" id="myPremiumButtonElement" ref="premiumButtonElement")

                    div(style="display: flex" class="ml-8")
                        div(class="header-btn")
                            template(v-if="user.user_id !== 0")
                                v-dialog(max-width="600" width="600" style="z-index:99999;")
                                    template(v-slot:activator="{on}")
                                        v-btn(v-on="on" class="white--text p-0 mr-4 clr-pink")
                                            v-icon(class="" style="font-size:23px;") mdi-bell-outline
                                            v-icon(v-show="eventDirtyFlag" class="red--text" style="position: absolute; left:14px; padding:-8px; font-size:10px;") mdi-circle
                                    DialogEvents

                        div(class="header-btn")
                            template(v-if="user.user_id !== 0")
                                v-dialog(v-model="dialog" width="400" v-click-outside="{include: include}" style="z-index:99999;")
                                    template(v-slot:activator="{on}")
                                        v-btn(style="display:none" color="blue6" v-on="on" class="p-0 mr-4 included clr-pink" id="dialogCompetition")
                                            v-icon(class=" pl-1 pr-1" style="font-size:20px;") $trophy
                                    template(v-slot:default="dialog")
                                        DialogCompetitions(:checkShortCode="code" @closeDialog="closeDialog")

                            //- SelectLanguagePopupWindow(v-if="user.user_id === 0")

                            v-menu(offset-y dense style="z-index:99999;")
                                template(v-slot:activator="{ on }")
                                    v-btn(color="blue6 clr-pink" v-on="on" class="white--text p-0")
                                        v-icon(class="pl-1 pr-1" style="font-size:23px;") mdi-account-outline

                                VisitorSettingsPopupWindow(v-if="user.user_id === 0" @aboutUsDialogOpen="setAboutUsDialogOpen()")
                                UserSettingsPopupWindow(v-if="user.user_id !== 0")

        NavigationTabs(v-if="!loadingState")
        UserAccount(v-if="user.user_id !== 0" v-model="getShowUserAccount")
        UserSettings(v-model="getShowUserSettings")
        UserInviteFriend(v-model="getShowUserInviteFriend")

        AboutUsPopupWindow(:aboutUsDialogOpen="aboutUsDialogOpen")

        div(v-show="getShowStockCards" style="position:absolute; top:180px; left:248px; border:0px solid orange; width: calc(100% - 250px);height: calc(100% - 210px);overflow: auto")
            div(class="stock-card-placeholder" style="border:0px solid; width: 100%; position: relative")
                div(style="display: flex; flex-wrap: wrap" class="stocks-test-parent")
                    SkeletonStockCard(v-if="!getCheckWhenFinishedCaching" v-for="index in getStockIds.length" class="home-stock-card" style="width:25%; border:0px solid;")
                    StockCard(v-for="(stock, index) in getCachedStocks" v-show="stock.theme_id === getLastCheckedTheme && getCheckWhenFinishedCaching"
                              :key="index"
                              :theme_id="Number(stock.theme_id)"
                              :stock="stock"
                              :resizeBetweenFix="(stock.theme_id === getLastCheckedTheme)"
                              ref="stockCardElement"
                              class="home-stock-card" style="width:25%; border:0px solid;")
</template>

<script>
/* eslint-disable no-console */
"use strict";

import ApiService from './../Services/ApiService';

import { mapGetters, mapActions, mapMutations } from "vuex";
import Ticker from "../components/Ticker.vue";
import NavigationTabs from "../components/NavigationTabs.vue";
import DialogCompetitions from "../components/DialogCompetitions.vue";
import DialogEvents from "../components/DialogEvents.vue";
import PremiumButton from "../components/PremiumButton.vue";
import UserSettings from "./landing/UserSettings.vue";
import UserAccount from "./landing/UserAccount.vue";
import UserInviteFriend from "./landing/UserInviteFriend.vue";
import VisitorSettingsPopupWindow from "./../components/VisitorSettingsPopupWindow.vue";
import UserSettingsPopupWindow  from "./../components/UserSettingsPopupWindow.vue";
import SelectLanguagePopupWindow from "./landing/SelectLanguagePopupWindow.vue";
import AboutUsPopupWindow from "./../components/AboutUsPopupWindow.vue";
import i18n from "@/plugins/i18n";
import ApiStocks from "@/Services/ApiStocks.js";
import Cookies from 'js-cookie';
import SkeletonStockCard from './home/SkeletonStockCard.vue';
import StockCard from './home/StockCard.vue';
import _ from "lodash";

export default {
    name: "Application",
    components: {
        Ticker,
        VisitorSettingsPopupWindow,
        UserSettingsPopupWindow,
        NavigationTabs,
        UserAccount,
        UserSettings,
        UserInviteFriend,
        PremiumButton,
        SelectLanguagePopupWindow,
        AboutUsPopupWindow,
        ApiStocks,
        DialogCompetitions,
        DialogEvents,
        SkeletonStockCard,
        StockCard,
    },
    created: async function() {
        if(localStorage.user === undefined) {
            const urlParams = new URLSearchParams(window.location.search);
            if(urlParams.get('tab') !== null) {
                window.location.href = `/?stockOverview=${window.location.href}`;
            } else if(urlParams.get('unsubscribe_email_newsletter') !== null) {
                window.location.href = `/?unsubscribe_email_newsletter=true`;
            } else if(urlParams.get('show_premium') !== null) {
                window.location.href = `/?show_premium=true`;
            }
        }

        this.path = window.location.pathname;

        if(localStorage.getItem('user') === null) {
            const response = (await ApiService.userLogin({
                email: this.VUE_APP_VISITOR_USERNAME,
                password: this.VUE_APP_VISITOR_PASSWORD,
            })).data;

            console.log(response);

            localStorage.setItem('user', JSON.stringify(response));

            // copy paste from Intercom.com for visitors // AB 2023-03-27
            // TODO: uncomment later...
            // window.intercomSettings = {
            //     api_base: "https://api-iam.intercom.io",
            //     app_id: "q0r4rtur"
            // };

            // (function() {
            //     var w=window;
            //     var ic=w.Intercom;
            //     if (typeof ic==="function") {
            //         ic('reattach_activator');
            //         ic('update',w.intercomSettings);
            //     } else {
            //         var d=document;
            //         var i=function() {
            //             i.c(arguments);
            //         };
            //         i.q=[];
            //         i.c=function(args) {
            //             i.q.push(args);
            //         };
            //         w.Intercom=i;
            //         var l=function() {
            //             var s=d.createElement('script');
            //             s.type='text/javascript';
            //             s.async=true;
            //             s.src='https://widget.intercom.io/widget/q0r4rtur';
            //             var x=d.getElementsByTagName('script')[0];
            //             x.parentNode.insertBefore(s,x);
            //         };
            //         if(document.readyState==='complete') {
            //             l();
            //         } else if (w.attachEvent) {
            //             w.attachEvent('onload',l);
            //         } else {
            //             w.addEventListener('load',l,false);
            //         }
            //     }
            // })();
            // END copy paste

        }

        this.user = JSON.parse(localStorage.getItem('user'));

        if(this.user.user_id !== 0) {
            this.setShowPreLoadScreen(false);
        }

        i18n.locale = JSON.parse(this.user.settings).language;

        this.handleUserAction(JSON.parse(localStorage.user));

        // --------------------
        if(localStorage.user) {
            this.user = JSON.parse(localStorage.user);

            if (this.user.subscription_id != null) {
                this.is_showPremiumBtn = false;

                this.$store.commit("setUserSubscribed", true);
                this.$store.commit("setUserCancelSubscribed", false);
            } else {
                this.$store.commit("setUserSubscribed", false);
                this.$store.commit("setUserCancelSubscribed", true);
            }
        } else if (this.getCookie("userInfo")) {
            this.user = JSON.parse(this.getCookie("userInfo"));
        }

        if (JSON.parse(this.user.settings).language) {
            this.language = JSON.parse(this.user.settings).language;
        }

        if (this.getCookie("is_email") == "true") {
            this.$store.commit("setSelectedResearchTabIndex", JSON.parse(this.user.settings).length);
        }
        // --------------------

        console.log("Application CREATED");
        await this.load(this.user.user_id);

        // const url = window.location.href;
        // const hostname = (new URL(url)).hostname;

        // console.log(hostname);

        // if(this.user.user_id !== 0 && hostname !== 'localhost') {
        //     const APP_ID = process.env.VUE_APP_ONE_SIGNAL_DESKTOP_APP_ID;

        //     await OneSignal.push(() => {
        //         OneSignal.init({
        //             appId: APP_ID
        //         });
        //     });

        //     const playerId = await OneSignal.getUserId();

        //     if(playerId === null) {
        //         document.addEventListener('click', this.setExternalId);
        //     }

        //     if(playerId !== null) {
        //         const user_id = this.user.user_id;

        //         console.log('getUserId...');
        //         console.log(`PlayerId is: ${playerId}`);
        //         console.log(`UserId is: ${user_id}`);

        //         await this.loadNotificationUserOnPlayerId(playerId);

        //         console.log(this.getNotificationUser);

        //         let existingNotificationUserPlayerId = null;
        //         let externalUserId = '';

        //         if(this.getNotificationUser !== null) {
        //             existingNotificationUserPlayerId = this.getNotificationUser.id;
        //             externalUserId = this.getNotificationUser.external_user_id;
        //         }

        //         console.log(existingNotificationUserPlayerId);
        //         console.log(externalUserId);

        //         if(playerId === existingNotificationUserPlayerId && externalUserId === '') {
        //             console.log('externalUserId is not set');

        //             const dataObject = {
        //                 player_id: playerId,
        //                 user_id: user_id
        //             };

        //             await this.loadExternalUserIdOnPlayerIdForDesktop(dataObject);
        //         }
        //     }
        // }

        for(const competition of this.getCompetitions) {
            if(localStorage.getItem(`${competition.short_code}`) !== null) {
                this.shortCodeSet = competition.short_code;
            }
        }

        // we update VUEX data for 12 hours
        setInterval(async () => {
            await this.load(this.user.user_id);
        }, 12*60*60*1000);

        setInterval(async () => {
            await this.checkEvents(this.user.user_id);
        }, 1000*60*60);

        // TODO: uncomment later...
        // this.connectWithIntercom();

        // --------------------
        // Moved this block up above - Application CREATED,
        // so need to make playerId work for onesignal
        // before moving this block here again
        // if(localStorage.user) {
        //     this.user = JSON.parse(localStorage.user);

        //     if (this.user.subscription_id != null) {
        //         this.is_showPremiumBtn = false;

        //         this.$store.commit("setUserSubscribed", true);
        //         this.$store.commit("setUserCancelSubscribed", false);
        //     } else {
        //         this.$store.commit("setUserSubscribed", false);
        //         this.$store.commit("setUserCancelSubscribed", true);
        //     }
        // } else if (this.getCookie("userInfo")) {
        //     this.user = JSON.parse(this.getCookie("userInfo"));
        // }

        // if (JSON.parse(this.user.settings).language) {
        //     this.language = JSON.parse(this.user.settings).language;
        // }

        // if (this.getCookie("is_email") == "true") {
        //     this.$store.commit("setSelectedResearchTabIndex", JSON.parse(this.user.settings).length);
        // }
        // --------------------
    },
    data() {
        return {
            aboutUsDialogOpen: false,
            user: null,
            path: "",
            dialog: false,
            showMessage: false,
            showUserSettings: false,
            showUserInviteFriend: false,
            loadingState: "amber",
            language: null,
            showPP: true,
            is_showPremiumBtn: true,
            shortCodeSet: null,
            code: '',
            eventDirtyFlag: true,
            VUE_APP_VISITOR_USERNAME: process.env.VUE_APP_VISITOR_USERNAME,
            VUE_APP_VISITOR_PASSWORD: process.env.VUE_APP_VISITOR_PASSWORD
        };
    },
    watch: {
        eventDirtyFlag () {
            this.eventDirtyFlag = true;
        },
        length(val) {
            this.tab = val - 1;
        },
        search() {
            if (this.items.length > 0) return; // Items have already been loaded
        },
        getShortCode() {
            this.code = this.shortCodeSet;
            this.dialog = true;
        }
    },
    computed: {
        ...mapGetters([
            "getShowStockCards",
            "getLastCheckedTheme",
            "getCachedStocks",
            "getWatchlistItems",
            "getWatchlistItem",
            "getFinancials",
            "getMapSectors",
            "getMapExchanges",
            "getMapCompanies",
            "getResearchs",
            "getResearchStaleCount",
            "screenerFilters",
            "userTradePlans",
            "userTradePlansActiveCount",
            "getMapUserWatchlists",
            "getMapUserWatchlistItems",
            "getMapStocks",
            "getAllStocks",
            "getWatchlists",
            "getCompetitions",
            "getEarningsDateArray",
            "getTabIndex",
            "getUserSettings",
            "getUser",
            "getCompanyCalendars",
            "getMapUserDiary",
            "getUserAccounts",
            "getShowUserAccountMenu",
            "getNotificationUser",
            "getShowUserSettings",
            "getShowUserInviteFriend",
            "getShowUserAccount",
            "getSelectedThemes",
            "getStocksOfTheme",
            "getStocksFromArrayOfStocks",
            "getAllCompaniesAndReports",
            "getCachedCompaniesAndReports",
            "getCheckWhenFinishedCaching",
            "getStockIds"
        ]),
        stock_ids() {
            return this.getSelectedThemes.find((t) => t.theme_id === this.getLastCheckedTheme).stock_ids;
        },
        getShortCode() {
            return this.shortCodeSet;
        },
        message: {
            get() {
                return this.$store.getters.getMessage;
            },
            set(v) {
                if (!v) {
                    this.$store.commit("setMessageClear");
                }
            },
        },
        userSubscribed: {
            get() {
                return this.$store.getters.getUserSubscribed;
            },
        },
        userDiaries() {
            return this.$store.getters.getMapUserDiary;
        }
    },
    methods: {
        ...mapActions([
            "checkEvents",
            "loadFinancials",
            "loadFinancials_year",
            "loadUser",
            "loadUserPortfolioPlan",
            "loadUserDiary",
            "loadUserTradePlans",
            "loadUserTradeHistory",
            "loadSectors",
            "loadAllSectors",
            // "loadSectorAverages",
            "loadTx",
            "loadTrade",
            "loadScreeners",
            "loadCompaniesFourDataPoints",
            "loadAllCompaniesAndReports",
            "loadCompanies",
            "loadCompanyAnalysts",
            "loadCompanyWebcasts",
            "loadExchanges",
            "loadEarningsdatenext",
            "loadStocks",
            "loadUserResearch",
            "loadUserWatchLists",
            "loadCompetitions",
            "loadNotifications",
            "loadUserCompetitions",
            "loadUserWatchlistJoins",
            "loadUserWatchListItems",
            "loadWLColumns",
            "loadChartOverlays",
            "clickUserNavTab",
            "setRemoveNavigationTabsAction",
            "setAddNavigationTabsAction",
            "setNavigationTabsAction",
            "setPushToStocksAction",
            "handleUserAction",
            "loadUserAccounts",
            "loadAllUserAccounts",
            "loadCompanyDataNeeded",
            "loadAllStocksForAutocompleteOnStartup",
            "loadExchangeRates",
            "loadAllNewsTags",
            "loadUserScreeners",
            "loadRecents",
            "loadExternalUserIdOnPlayerIdForDesktop",
            "loadNotificationUserOnPlayerId",
            // "loadStocksOfTheme",
            // "loadStocksFromArrayOfStocks",
        ]),
        ...mapMutations([
            'setShowPreLoadScreen',
            'setRegisterType',
            'setRegisterWindows'
        ]),
        login() {
            this.setRegisterType('login');
            this.setRegisterWindows(true);
        },
        goToStartPage() {
            const element = document.getElementById('homeElement');

            element.click();
        },
        setAboutUsDialogOpen() {
            this.aboutUsDialogOpen = true;

            setTimeout(() => {
                this.aboutUsDialogOpen = false;
            }, 300);
        },
        openPremiumWindow() {
            this.$refs.premiumButtonElement.dialog = true;
        },
        closeDialog(dialog) {
            this.dialog = dialog;
        },
        isPdfReportsTableLoaded() {
            this.$store.commit('setIsPdfReportsTableLoaded', 0);

            setTimeout(() => {
                this.$store.commit('setIsPdfReportsTableLoaded', 1);
            }, 50);
        },
        include () {
            return [document.querySelector('.included')];
        },
        async load(user_id) {
            // await this.loadCompanyWebcasts();
            // await this.loadCompanyAnalysts();

            this.loadCompaniesFourDataPoints();
            this.loadSectors();
            // this.loadSectorAverages();
            this.loadExchanges();
            this.loadAllStocksForAutocompleteOnStartup();
            this.loadCompetitions();
            this.loadExchangeRates();
            this.loadAllNewsTags();

            console.time('User Data');
            await this.loadUser(user_id);
            await this.checkEvents(user_id);
            await this.loadRecents(user_id);

            setTimeout(async () => {
                // await this.loadChartOverlays(user_id);
                await this.loadUserDiary(user_id);
                await this.loadUserTradePlans(user_id);
                await this.loadUserResearch(user_id);
                await this.loadWLColumns(user_id);
                await this.loadUserCompetitions(user_id);
                await this.loadNotifications(user_id);
                await this.loadUserWatchLists(user_id);
                await this.loadUserWatchListItems(user_id);  // also loads companies and stocks
                await this.loadUserWatchlistJoins(user_id);
                await this.loadScreeners(user_id);
                await this.loadUserPortfolioPlan(user_id);
                // await this.loadUserTabs(user_id);
                // await this.loadRecents(user_id);
                await this.loadTx(user_id);
                await this.loadUserTradeHistory(user_id);
                await this.loadUserAccounts(user_id);
                await this.loadUserScreeners(user_id);

                await this.loadAllUserAccounts();  // THIS LOOKS DANGEROUS !
            }, 200);

            console.timeEnd('User Data');

            this.loadingState = false;
        },
        // TODO: uncomment later...
        // connectWithIntercom () {
        //     // Send Intercom custom User data on login.
        //     let user = JSON.parse(localStorage.getItem('user'));

        //     if (user.user_id) {
        //         this.$intercom.boot({
        //             user_id: user.user_id,
        //             email: user.email,
        //             name: user.email.split('@')[0],
        //             user_hash: hashInHex,

        //             researches: this.getResearchs.length,
        //             researches_stale: this.getResearchStaleCount,
        //             screeners: this.screenerFilters.length,
        //             trade_plans: this.userTradePlans.length,
        //             trade_plans_active: this.userTradePlansActiveCount,
        //             user_type: user.type,
        //             email_newsletter: user.email_newsletter,
        //             userSubscribed: this.userSubscribed,
        //             watchlists: this.getWatchlists.length,
        //             watchlist_items: this.getWatchlistItems.length,
        //             number_of_trade_journal_entries: this.userDiaries.length,
        //         });
        //     }
        // },
        customFilter(item, searchText) {
            // before update, the return value was only the ticker value of object, after update, return value  is whole object
            const s = searchText.toLowerCase();

            if (item.ticker.toLowerCase().indexOf(s) > -1 || item.name.toLowerCase().indexOf(s) > -1) {
                return item;
            }
        },
        async onChange(stock) {
            await this.loadCompanyDataNeeded(stock);

            this.$router.push({name: 'landing-page.stock-detail', params: {stock_id: stock.stock_id}});
        },
        getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(";");

            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];

                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }

            return "";
        },
        logout() {
            localStorage.removeItem('user');
            Cookies.remove('user');

            window.location.href = "/";
        },
        // setExternalId() {
        //     setTimeout(async () => {
        //         const playerId = await OneSignal.getUserId();

        //         console.log('Added?');
        //         console.log(playerId);

        //         if(playerId !== null) {
        //             const dataObject = {
        //                 player_id: playerId,
        //                 user_id: this.user.user_id
        //             };

        //             await this.loadExternalUserIdOnPlayerIdForDesktop(dataObject);

        //             document.removeEventListener('click', this.setExternalId);
        //         }
        //     }, 5000);
        // }
    }
};
</script>

<style>
.ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.cursor-pointer {
    cursor: pointer;
}

.v-input__control label {
    margin-bottom: 0;
}


.ta_construction {
    z-index: 9999;
    transform: rotate(39deg);
    top: 90px;
    left: 1330px;
    width: 500px;
    height: 30px;
    position: absolute;
    background-image: repeating-linear-gradient(45deg, black, black 10px, yellow 10px, yellow 20px);
}

.ta_ribbon {
    z-index: 1;
    transform: rotate(20deg);
    position: absolute;
    top: 30px;
    right: -40px;
    background: #eed246;
    color: #444748;
    width: 400px;
    height: 40px;
    text-align: center;
    font-size: 1.5em;
    font-weight: bold;
    box-shadow: 30px 30px 100px 30px rgba(0, 0, 0, 0.3);
    border-bottom: 2px #932e1e solid;
    border-top: 2px #ffae6a solid;
}

.discreteIcon {
    visibility: hidden;
}

.discreteIcon:hover {
    visibility: visible;
    color: red;
}

.ta_sticker {
    background-color: #ebd14c;
    background-image: linear-gradient(140deg, rgba(255, 255, 220, 0), rgba(255, 255, 220, 0.3));
    transform: rotate(4deg);
    position: absolute;
    top: 100px;
    right: 100px;
    color: #444748;
    width: 340px;
    height: 530px;
    padding: 20px;
    text-align: center;
    font-size: 0.9em;
    font-family: Chalkduster;
    box-shadow: 30px 30px 100px 30px rgba(0, 0, 0, 0.3);
}

.ta_app {
    position: sticky;
    top: 0;
}

.v-btn {
    min-width: 0 !important;
}

#userAccountsContainer .v-list-item__title {
    font-size: 15px !important;
}

#userAccountsContainer .v-list--dense {
    padding: 0;
}

html {
    font-size: 12px;
}
</style>

<style scoped>



.ta_brand_header_bg_clr {
    border-radius: 12px 12px 0 0;
    padding: 8px 5px;
}

.ta_brand_header_bg_clr .no-gutters {
    align-items: center;
    justify-content: space-between;
    padding: 0;
}

>>>.header-btn .v-btn {
    border-radius: 6px;
    color: #EDBC9B;
    /*margin: 0 1em 0 0;*/
    font-size:15px;
    background-color: transparent !important;
    border: 1px solid rgba(237,188,155,1) !important;
    cursor: pointer;
}


>>>.header-btn.clr-pink button,
>>>.clr-pink.v-btn {
    background-color: rgba(237,188,155,1) !important;
    color: #144b4d;
    box-shadow: none;
}

>>>.clr-pink.v-btn .v-icon {
    color: #144b4d;
}

.header-logo {
    padding-left: 10px;
    min-height: 48px;
}

.header-logo:hover {
    cursor: pointer;
}

.header-logo .v-image {
    height: 68px;
}

>>>.header-logo .v-image__image--cover {
    background-size: contain;
}

.header-search,
>>>.header-btn .v-btn {
    border: 1px solid;
    border-radius: 6px;
    min-width: auto;
    height: 40px;
    width: 40px;
}

>>>.brd-radius .v-btn {
    border-radius: 100px;
    min-width: 100px;
    width: auto;
}

>>>.header-search.theme--light.v-text-field--solo>.v-input__control .v-input__slot .v-input__append-inner {
    border-left: 1px solid;
    cursor: pointer;
}

.header-search,
>>>.header-search.theme--light.v-text-field--solo>.v-input__control .v-input__slot .v-input__append-inner {
    border-color: rgba(237,188,155,.6);
}

>>>.header-search.theme--light.v-text-field--solo>.v-input__control,
>>>.header-search.theme--light.v-text-field--solo>.v-input__control .v-input__slot .v-input__append-inner,
>>>.header-search.theme--light.v-text-field--solo>.v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append {
    min-height: 38px;
}

>>>.header-search.theme--light.v-text-field--solo>.v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append {
    height: 100%;
    padding: 0 18px;
}

>>>.header-search.theme--light.v-text-field--solo>.v-input__control,
>>>.header-search.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
    -webkit-box-shadow: none;
    box-shadow: none;
}

>>>.header-search.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
    background: transparent;
    padding-right: 0;
}

>>>.header-search.theme--light.v-text-field--solo>.v-input__control>.v-input__slot .v-input__append-inner {
    padding-left: 0;
}

>>>.header-search.theme--light.v-text-field--solo>.v-input__control>.v-input__slot .v-icon:before,
>>>.header-search.theme--light.v-text-field--solo>.v-input__control>.v-input__slot .v-icon:after {
    color: white;
}

>>>.header-search.theme--light.v-text-field--solo>.v-input__control>.v-input__slot:before {
    display: none;
}

>>>.header-search.theme--light.v-input input,
>>>.header-search.theme--light.v-input input::placeholder,
>>>.header-search.theme--light.v-input label,
>>>.header-search.theme--light.v-select .v-select__selections {
    color: white;
    font-size: 12px;
    line-height: 1.6;
}

.v-autocomplete__content.v-menu__content {
    border-radius: 6px;
}

</style>
